import React from 'react'
import styled from 'styled-components'
import colors from '@constants/colors'
import Loader from 'react-loader-spinner'

export default ({ backgroundColor }) => {
    return (
        <Container backgroundColor={backgroundColor}>
            <Loader
                type="Oval"
                color={colors.COLOR_PRIMARY}
                height={32}
                width={32}
            />
        </Container>
    )
}

const Container = styled.div`
    padding: 20px;
    text-align: center;
    background-color: ${(p) =>
        p.backgroundColor ? p.backgroundColor : 'transparent'};
`
